module.exports = __webpack_public_path__ + "img/thumbnail-tab-slide-sofyre.1fec1e83.webp";